import api from "./api";
import store from "../store";
import permissions from 'comunet-btg-utah-repository-shared/permissions';
import * as msal from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
        authority: "https://login.microsoftonline.com/" + process.env.VUE_APP_MSAL_TENANT_ID,
        redirectUri : process.env.VUE_APP_MSAL_REDIRECT_URI,
        postLogoutRedirectUri : process.env.VUE_APP_MSAL_POST_LOGOUT_REDIRECT_URI
    },
    cache: {
        cacheLocation: "localStorage"
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {	
                    return;	
                }
                switch (level) {	
                    case msal.LogLevel.Error:
                        // eslint-disable-next-line no-console
                        console.error(message);	
                        return;	
                    case msal.LogLevel.Info:
                        // eslint-disable-next-line no-console
                        console.info(message);	
                        return;	
                    case msal.LogLevel.Verbose:
                        // eslint-disable-next-line no-console
                        console.debug(message);	
                        return;	
                    case msal.LogLevel.Warning:
                        // eslint-disable-next-line no-console
                        console.warn(message);	
                        return;	
                    default:
                        return;
                }
            },
            logLevel: process.env.VUE_APP_AUTH_LOGGING_ENABLED === "true" ? msal.LogLevel.Verbose : msal.LogLevel.Error
        }
    }
};

export const msalInstance = new msal.PublicClientApplication(msalConfig);

export function getMSALRequest() {
    let request = {};
    request.scopes = [process.env.VUE_APP_MSAL_SCOPES];
    
    const accounts = msalInstance.getAllAccounts();

    if (accounts && accounts.length > 0) {
        request.account = accounts[0];
    }

    return request;
}

export async function acquireTokenSilent() {
    return await msalInstance.acquireTokenSilent(getMSALRequest());
}

export async function acquireTokenRedirect() {
    return await msalInstance.acquireTokenRedirect(getMSALRequest());
}

export async function logout() {
    await msalInstance.logoutRedirect(getMSALRequest());

    forgetUser();
}

export async function processLogin() {
    let response = await api.getUser();

    store.commit("authStore/updateUser", response);
}

export function forgetUser() {
    store.commit("authStore/removeUser");
}

export function hasPermissions(requiredPermissions, denyReadOnly) {
    // get user from the store
    let user = store.state.authStore.user;

    // find the access rights from the user object from the store
    let userAccessRights = {};

    if (user && user.UserProfile && user.UserProfile.Permissions) {
        userAccessRights = user.UserProfile.Permissions;
    }

    return permissions.hasPermissions(userAccessRights, requiredPermissions, denyReadOnly);
}

export function currentUserIsReadOnly() {
    // the second parameter ensures that this call returns false if we are a read only user
    // we don't need to check any other permissions, hence the empty first parameter
    return !hasPermissions([], true);
}

export function currentUserIsAdmin(){
    return hasPermissions([permissions.ACCESS_LEVELS.ADMIN], true);
}
